import { Grid, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import React from "react";
import CardSys from "../../components/cardSys";
import TitlePages from "../../components/generic/titlePages";
import { api } from "../../services/api";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import ButtonConsultLogs from "../../components/buttonConsultLogs";
import ButtonSyncManual from "../../components/buttonSyncManual";
import BoxTheme from "../../components/generic/box";
import InputHost from "../../components/generic/inputHost";
import InputDatabase from "../../components/generic/inputDatabase";
import InputSchema from "../../components/generic/inputSchema";
import ButtonEdit from "../../components/buttonEdit";
import SelectSyncHourOne from "../../components/selectSyncHourOne";
import SelectSyncHourTwo from "../../components/selectSyncHourTwo";
import InputPort from "../../components/generic/inputPort";
import InputUserName from "../../components/generic/inputUserName";
import InputPasswordDb from "../../components/generic/inputPasswordDb";
import InputDialect from "../../components/generic/inputDialect";
import CancelButton from "../../components/generic/cancelButton";
import ButtonSave from "../../components/buttonSave";
import ModalSys from "../../components/modal";
import SyncSucessModules from "../../components/syncSucessModules";
import SyncError from "../../components/syncError";
import SyncWarning from "../../components/syncWarning";

export default function Synchronize() {
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    host: "",
    port: "",
    database: "",
    schema: "",
    username: "",
    password: "",
    dialect: "",
    sync1: "",
    sync2: "",
  });
  const [showdb, setShowDb] = useState(false);
  const [toggle, setToggleField] = useState(false);
  const [modal, setModal] = useState({ visible: false });
  const [sucessSync, setSucessSync] = useState(false);
  const [warningSync, setWarningSync] = useState(false);
  const [errorSync, setErrorSync] = useState(false);
  const [id, setId] = useState(0);
  const [buttons,setButtons] = useState(true)

  const show = () => setShowDb(true);
  const hide = () => setShowDb(false);
  

  const changeFields = () => {
    setToggleField(!toggle);
  };

  async function getSyncDb() {
    handleLoading(true);

    try {
      const { data: sync } = await api({ method: "GET", url: "/sync" });
      setId(sync?.id)
      setInputs((obj) => {
        obj.host = sync?.host;
        obj.database = sync?.database;
        obj.port = sync?.port;
        obj.schema = sync?.schema;
        obj.sync1 = sync?.sync1;
        obj.sync2 = sync?.sync2;
        obj.password = sync?.password;
        obj.username = sync?.username;
        obj.dialect = sync?.dialect;

        return { ...obj };
      });
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }

    handleLoading(false);
  }

  async function syncManual() {
    handleLoading(true);
    try {
      const { data: syncManual } = await api({
        method: "POST",
        url: "/sync/sync",
      });
      setSucessSync(true);
    } catch (err) {
      console.log(err);
      if (err.response.data.error == 400) {
        setErrorSync(true);
      } else {
        setWarningSync(true);
      }
      // handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  }

  const handleSubmit = async (event) => {
    handleLoading(true);
    try {
      const { data } = await api({
        method: "POST",
        url: "/sync",
        data: {
          id: id,
          host: inputs.host,
          port: inputs.port,
          database: inputs.database,
          schema: inputs.schema,
          username: inputs.username,
          password: inputs.password,
          dialect: inputs.dialect,
          sync1: inputs.sync1,
          sync2: inputs.sync2,
        },
      });
      handleToast(true, data.toast, data.message);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  };

  useEffect(() => {
    getSyncDb();
  }, []);

  console.log(errorSync);

  return (
    <>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item>
          <TitlePages>Sincronização</TitlePages>
        </Grid>
      </Grid>
      <CardSys>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          >
          { buttons && 
          <Grid
            item
            xs={6.3}
            direction="row"
            justifyContent="space-between"
            marginLeft={"9px"}
            alignItems="center"
            sx={{ display: "flex" }}
          >

              <ButtonSyncManual onClick={syncManual}></ButtonSyncManual>
            <ButtonConsultLogs
            onClick={() => navigate("/logs")}
            ></ButtonConsultLogs>
          </Grid>
          }

          <Grid
            item
            xs={6}
            direction="row"
            justifyContent="center"
            alignItems="center"
            marginTop={"15px"}
          >
            <Typography
              sx={{
                size: "16px",
                lineHeight: "20.11px",
                color: "#2C4992",
                fontWeight: "bold",
              }}
            >
              Cobmais
            </Typography>
          </Grid>
          <Grid
            container
            xs={8}
            direction="row"
            justifyContent="end"
            alignItems="end"
            marginTop={"15px"}
            marginRight={"200px"}
            display={"flex"}
            gap={4}
          >
            <Grid
              item
              xs={2}
              direction="row"
              alignItems="end"
              marginTop={"15px"}
            >
              <SelectSyncHourOne
                onChange={({ target }) => {
                  setInputs((obj) => {
                    obj.sync1 = target.value;
                    return { ...obj };
                  });
                }}
                views={['hours']}
                value={inputs.sync1}
                disabled={!toggle}
              ></SelectSyncHourOne>
            </Grid>

            <Grid
              item
              xs={2}
              direction="row"
              justifyContent="end"
              alignItems="end"
              marginTop={"15px"}
            >
              <SelectSyncHourTwo
                onChange={({ target }) => {
                  setInputs((obj) => {
                    obj.sync2 = target.value;
                    return { ...obj };
                  });
                }}
                value={inputs.sync2}
                disabled={!toggle}
              ></SelectSyncHourTwo>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="center"
            alignItems="center"
            marginTop={"15px"}
          >
            <BoxTheme component="form" noValidate autoComplete="off">
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid
                  item
                  xs={6}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputHost
                    onChange={({ target }) => {
                      setInputs((obj) => {
                        obj.host = target.value;
                        return { ...obj };
                      });
                    }}
                    value={inputs.host}
                    disabled={!toggle}
                  ></InputHost>
                </Grid>
              </Grid>
              {showdb && (
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid
                    item
                    xs={6}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <InputPort
                      onChange={({ target }) => {
                        setInputs((obj) => {
                          obj.port = target.value;
                          return { ...obj };
                        });
                      }}
                      value={inputs.port}
                      disabled={!toggle}
                    ></InputPort>
                  </Grid>
                </Grid>
              )}
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                marginTop={"15px"}
              >
                <Grid
                  item
                  xs={6}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputDatabase
                    onChange={({ target }) => {
                      setInputs((obj) => {
                        obj.database = target.value;
                        return { ...obj };
                      });
                    }}
                    value={inputs.database}
                    disabled={!toggle}
                  ></InputDatabase>
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                marginTop={"15px"}
              >
                <Grid
                  item
                  xs={6}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <InputSchema
                    onChange={({ target }) => {
                      setInputs((obj) => {
                        obj.schema = target.value;
                        return { ...obj };
                      });
                    }}
                    value={inputs.schema}
                    disabled={!toggle}
                  ></InputSchema>
                </Grid>
              </Grid>
              {showdb && (
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  marginTop={"15px"}
                >
                  <Grid
                    item
                    xs={6}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <InputUserName
                      onChange={({ target }) => {
                        setInputs((obj) => {
                          obj.username = target.value;
                          return { ...obj };
                        });
                      }}
                      value={inputs.username}
                      disabled={!toggle}
                    ></InputUserName>
                  </Grid>
                </Grid>
              )}
              {showdb && (
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  marginTop={"15px"}
                >
                  <Grid
                    item
                    xs={6}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <InputPasswordDb
                      onChange={({ target }) => {
                        setInputs((obj) => {
                          obj.password = target.value;
                          return { ...obj };
                        });
                      }}
                      value={inputs.password}
                      disabled={!toggle}
                    ></InputPasswordDb>
                  </Grid>
                </Grid>
              )}
              {showdb && (
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  marginTop={"15px"}
                >
                  <Grid
                    item
                    xs={6}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <InputDialect
                      onChange={({ target }) => {
                        setInputs((obj) => {
                          obj.dialect = target.value;
                          return { ...obj };
                        });
                      }}
                      value={inputs.dialect}
                      disabled={!toggle}
                    ></InputDialect>
                  </Grid>
                </Grid>
              )}
              <Grid
                item
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                marginTop={"25px"}
              >
                {!showdb && (
                  <ButtonEdit
                    sx={{
                      borderRadius: "0.7rem",
                      color: "white",
                      textTransform: "initial",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => {
                      show();
                      changeFields();
                      setButtons(false)
                    }}
                  >
                    Editar
                  </ButtonEdit>
                )}
              </Grid>

              {showdb && (
                <Grid
                  container
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Grid item>
                    <CancelButton
                      onClick={() => {
                        hide();
                        changeFields();
                        setButtons(true)
                      }}
                    ></CancelButton>
                  </Grid>
                  <Grid item>
                    <ButtonSave
                      onClick={() => {
                        hide();
                        changeFields();
                        handleSubmit();
                      }}
                      sx={{
                        borderRadius: "0.7rem",
                        color: "white",
                        textTransform: "initial",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      Salvar
                    </ButtonSave>
                  </Grid>
                </Grid>
              )}
            </BoxTheme>
          </Grid>
        </Grid>
      </CardSys>

      {sucessSync && (
        <ModalSys open={sucessSync} handleClose={() => setSucessSync(false)}>
          <SyncSucessModules
            handleClose={() => setSucessSync(false)}
          ></SyncSucessModules>
        </ModalSys>
      )}
      {errorSync && (
        <ModalSys open={errorSync} handleClose={() => setErrorSync(false)}>
          <SyncError
            onClick={() => {
              setErrorSync(false);
            }}
          ></SyncError>
        </ModalSys>
      )}
      {warningSync && (
        <ModalSys open={warningSync} handleClose={() => setWarningSync(false)}>
          <SyncWarning
            handleClose={() => setWarningSync(false)}
          ></SyncWarning>
        </ModalSys>
      )}
    </>
  );
}
